export default {
  totalPages: state => {
    return Math.ceil(state.itemsCount / state.limit)
  },
  currentPage: state => {
    return Math.ceil(state.skip / state.limit + 1)
  }
}
